import React from "react";
import { useState } from "react";
import Button from "./DefaultButton";
import BasicSelect from "../Task/BasicSelect";

const AdvancedButtonGroup = ({
  primaryText,
  primaryClick,
  primaryType,
  secondaryClick,
  secondaryText,
  secondaryType,
  styles,
  options,
  selectedAction,
  setSelectedAction,
  appliedFilterView,
  className,
  disableConditionForSave, //this condition is for whether we want to disable the save
  // filter button, in case of any specific condition
  disableSaveFilter, // this is different from above, in the sense that, here we don't have the feature to post
  //the saved filters in header configuration
}) => {
  return (
    <div className="flex items-center gap-2" style={{ ...styles }}>
      <Button variant="secondary" size="small" onClick={secondaryClick} type={secondaryType} className={className}>
        {secondaryText}
      </Button>
      {appliedFilterView ? (
        <BasicSelect
          options={options?.map((item) => ({ value: item?.value, label: item?.label, onClick: item?.onClick }))}
          label={"Action"}
          name="Action"
          onChange={(e) => {
            setSelectedAction(e.target.value);
            e.target.onClick(e, e.target.value);
          }}
          value={selectedAction}
          isButton={true}
          //   selectedOptions={visibleColumns
          //     ?.filter((item) => item.id === currentSelectedColumnValue)
          //     .map((item) => ({ value: item?.id, label: capitalizeString(item?.columnDef?.header) }))}
          //   showSearch={true}
        />
      ) : (
        <Button
          variant="primary"
          size="small"
          onClick={primaryClick}
          type={primaryType}
          className={className}
          isDisabled={disableConditionForSave.length == 0}
        >
          {primaryText}
        </Button>
      )}
    </div>
  );
};

export default AdvancedButtonGroup;
